import { useProject } from '../../project-hooks/useProject';
import { formatMoneyKroner } from '../../../utils';
import { ProjectInfoBoxGiversAndTime } from '../../project-info-box-givers-and-time/ProjectInfoBoxGiversAndTime';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import ProjectOwnerAndReceiver from '../project-owner-and-receiver/ProjectOwnerAndReceiver';
import ProjectProgress from '../../../components/project-progress/ProjectProgress';
import CollectedAmountAnimated from '../../collected-amount-animated/CollectedAmountAnimated';
import IsLive from '../is-live/IsLive';
import Image from '../../../components/image/Image';
import { isActive, isBirthdayProject } from '../../project-model';
import { Heading1, Heading2 } from '@sb1/ffe-core-react';
import { ProjectInactiveBanner } from '../project-inactive-banner/ProjectInactiveBanner';
import { ProjectInfoBoxSupport } from './ProjectInfoBoxSupport';
import styles from './ProjectInfoBox.module.less';

const ProjectInfoBox = ({ className = '', showSupportButtons = true, projectShareModalRef }) => {
    const project = useProject();
    const birthdayProject = isBirthdayProject(project);
    const projectIsActive = isActive(project);
    return (
        <div className={className}>
            <div className={styles.projectInfoBox}>
                <div className={['ffe-accent-mode', styles.waveSection].join(' ')}>
                    <div className={styles.titleAndCollected}>
                        <IsLive />
                        <Heading1
                            className={`${styles.projectTitle} ${project?.title?.length > 80 ? styles.long : ''}`}
                        >
                            {project.title}
                        </Heading1>
                        <div>
                            <Heading2 className={styles.collectedAmount} noMargin>
                                <span aria-hidden={true}>
                                    <CollectedAmountAnimated />
                                    <span className={styles.currency}> kr</span>
                                </span>
                                <ScreenReaderOnly tag={'span'}>
                                    {formatMoneyKroner(project?.collected_amount ?? 0)} innsamlet
                                </ScreenReaderOnly>
                            </Heading2>

                            <div className={styles.giverCountAndTimeRemaining}>
                                <ProjectInfoBoxGiversAndTime showDateTimeWithGeneralText />
                            </div>
                        </div>
                    </div>
                    {birthdayProject && <Image className={styles.birthdayImage} src={'causes/birthday-package.svg'} />}
                </div>
                <div className={styles.topSection}>
                    <ProjectProgress />
                    <ProjectOwnerAndReceiver />
                </div>
            </div>

            {showSupportButtons &&
                (projectIsActive ? (
                    <ProjectInfoBoxSupport projectShareModalRef={projectShareModalRef} />
                ) : (
                    <ProjectInactiveBanner project={project} />
                ))}
        </div>
    );
};

export default ProjectInfoBox;
